<template>
    <div class="header-toolbar">
        <div class="left-section logo" v-show="leftDiv === 'logo'"  @click="$router.push('/')">
            <img src="/assets/common/logo.png" >
        </div>

        <div class="left-section" v-show="leftDiv === 'blank'">
        </div>
        <div class="left-section" v-show="leftDiv === 'back'"  @click="$router.go(-1)">
            <ion-icon name="md-arrow-back"></ion-icon>
        </div>
        <div class="left-section config" v-show="leftDiv === 'config'"  @click="$router.push('/mypage/setting')">
            <img src="/assets/common/header-toolbar/config.png" width="24" height="24" />
        </div>

        <div class="title">
            <div>{{ title }}</div>
            <div class="main-title" v-show="mainTitle === 'true'">primary and secondary audio<br>learning platform</div>
        </div>

        <div class="right-section">
            <img src="/assets/common/header-toolbar/alram.png" width="18.72" height="22.2" @click="$router.push('/notice')" />
            <img src="/assets/common/header-toolbar/search.png" width="20.4" height="21.1" @click="$router.push('/search')" />
            <img src="/assets/common/hamburger.png" width="21" height="" @click="openHamburger()" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "StandardHeader",
        props: {
            leftDiv: String,
            title: String,
            mainTitle: String
        },
        data() {
            return {
            }
        },
        methods: {
            openHamburger() {
                document.querySelector('ion-menu-controller').open('end');
            }
        }
    }
</script>

<style scoped lang="scss">
    div.header-toolbar {
        width: 100%;
        height: 56px;
        background-color: white;
        border-bottom: 1px solid $line-third-color;

        display: flex;
        justify-content: space-between;
        align-items: center;

        div.left-section {
            width: 76px;
            padding-left: 24px;
            font-size: $font-base24;
            .logo {
                max-width: 87px;
                width: 85px;
                height: 25px;
            }
        }
        div.left-section.logo {
            width: 100px;
        }
        div.title {
            flex: 1;
            text-align: center;
            font-size: $font-base18;
            font-weight: $font-weight500;

            div.main-title {
                font-size: $font-base14;
                color: $primary-color;
            }
        }
        div.right-section {
            width: 111px;
            text-align: right;
            img {
                &:last-child {
                    vertical-align: text-top;
                }
                margin-right: 16px;
            }
        }
    }
</style>
